import { render, staticRenderFns } from "./MoreFeatures.vue?vue&type=template&id=05b3f5f6&scoped=true"
import script from "./MoreFeatures.vue?vue&type=script&lang=js"
export * from "./MoreFeatures.vue?vue&type=script&lang=js"
import style0 from "./MoreFeatures.vue?vue&type=style&index=0&id=05b3f5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3f5f6",
  null
  
)

export default component.exports